export default __webpack_public_path__ + "static/media/PDF_Icon_Small.ca638412.svg";